
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'app-loading-indicator',
})
export default class AppLoadingIndicator extends Vue {}
